import { action, makeObservable, observable, runInAction } from 'mobx';
import { ACCOUNT_TYPE } from 'src/constants';
import { ENDPOINT, HTTP_STATUS_RESPONSE_KEY } from 'src/constants/api';
import { ResponseDTO } from 'src/dto/base.dto';
import { IRegistrationBodyDTO, RegistrationDTO, RegistrationResponse } from 'src/dto/register.dto';
import { IHttpService } from 'src/services/http.service';
import { IAuthStore } from './auth/auth.store';

export interface IRegistrationStore {
	accountType?: ACCOUNT_TYPE;
	setAccountType(type: ACCOUNT_TYPE): void;
	register(dto: IRegistrationBodyDTO): Promise<boolean>;
}
export class RegistrationStore implements IRegistrationStore {
	@observable
	accountType?: ACCOUNT_TYPE;

	constructor(private readonly http: IHttpService, private authStore: IAuthStore) {
		makeObservable(this);
	}

	@action.bound
	setAccountType(type: ACCOUNT_TYPE): void {
		this.accountType = type;
	}

	public async register(dto: IRegistrationBodyDTO): Promise<boolean> {
		const url =
			this.accountType == ACCOUNT_TYPE.CORPORATE ? ENDPOINT.CORPORATE_REGISTRATION : ENDPOINT.INDIVIDUAL_REGISTRATION;
		const registrationDto = new RegistrationDTO(dto, url);
		const registrationResponse: ResponseDTO<RegistrationResponse> = await this.http.request<
			RegistrationDTO,
			RegistrationResponse
		>(registrationDto);
		if (registrationResponse.responseKey == HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
			const data = registrationResponse.data;
			runInAction(() => {
				this.authStore.setAuthenticated(true);
				this.authStore.setOtpToken(data?.token);
				this.authStore.setOtpExpiredAt(data?.otpExpiredAt);
			});
			return true;
		}
		return false;
	}
}
